export default __webpack_public_path__ + "static/media/sneaker-essential.06e152d3.jpg";